<style> .container {
    text-align: justify;
  }
</style>
<div class="container">
    <h1>Terms of Use Agreement</h1>

    <p> DevCare Vendor Management System ("DevCare Vendor Management System," "DevCare Vendor Management System," "WE,"
        "US") PROVIDES THIS WEB SITE AND ALL SITE-RELATED SERVICES, INCLUDING
        THE CONTENT AND CODE RELATED THERETO (COLLECTIVELY, THE "SITE") ARE SUBJECT TO YOUR COMPLIANCE WITH
        THE TERMS AND CONDITIONS ARE SET FORTH BELOW. PLEASE READ THIS TERMS OF USE AGREEMENT ("AGREEMENT")
        CAREFULLY BEFORE USING THIS SITE. Using the Site, you agree to be bound by these terms and conditions. Please do
        not
        use the Site if you disagree with these terms and conditions.
    </p>
    <p>
        <i>This Agreement confirms the partnership between the DevCare Vendor Management System and you, the Site
            visitor and/or
            registered user ("you"). We reserve the right to change this Agreement's terms and conditions at any
            time.</i>
    </p>
    <p>
        Changes to the Site, including eliminating or discontinuing Content or Features, restricting the hours of
        availability
        or limiting the amount of use permitted; or change any fees or charges for the use of the Site, including
        instituting
        new or increased fees or charges for the use of the Site or any other Site-related services or any feature
        thereof. Any
        changes we make will be effective immediately upon notice, which we may provide by any means, including, without
        limitation, posting on the Site or via electronic mail. Your use of the Site after such notice will determine
        acceptance
        of such changes. Review this Agreement periodically to ensure familiarity with the most current version. You
        agree to
        sign a non-electronic version of this Agreement upon our request.
    </p>
    <p>
        If you do not agree with (or cannot comply with) Agreements, then you may not use the Service, but please let us
        know by
        emailing dvmsadmin@devcare.com or info@devcare.com so we can try to find a solution. These Terms apply to all
        visitors,
        users and others who wish to access or use the Service.
    </p>
    <h2>Ownership; Proprietary Notices</h2>
    <p>
        © 2021 - DVMS. All Rights Reserved.
    </p>
    <p>
        The Site, including all pages within and all code related thereto, is the property of DevCare Vendor Management
        System.
        No portion of materials or code on these pages (or anywhere on the Site) may be reprinted or republished (other
        than as
        is necessary to view the page on your monitor) in any form without the express written permission of DevCare
        Vendor
        Management System.
    </p>
    <p>
        DVMS® is a registered service mark of the DevCare Vendor Management System. The following are trademarks and/or
        service
        marks owned by <a href="https://dvms.devcare.com/" target="_blank">https://dvms.devcare.com</a> and the DVMS logo. All other trademarks and/or service marks used in
        this Site
        are their respective owners' trademarks and/or service marks.
    </p>
    <p>
        The Site is owned and operated by us in conjunction with others under contractual arrangements. Unauthorized use
        of the
        materials on the Site may violate copyright, trademark, patent and other laws and is prohibited. You acknowledge
        that
        using the Site does not acquire any ownership rights.
    </p>
    <h2>Email Communications</h2>
    <p>
        By using our Service, you agree to subscribe to our email notifications from dvmsinfo@devcare.com or
        info@devcare.com
        for requisitions, interviews, engagements, invoices and document alerts we may send. However, you may opt-out of
        receiving communications from us by following the unsubscribe link on the emails and resubscribing to the email
        services
        whenever required.
    </p>
    <h2>Warranty Information; Disclaimer</h2>
    <p>
        THIS SITE, INCLUDING ANY CONTENT OR INFORMATION CONTAINED WITHIN IT OR ANY SITE-RELATED SERVICE, OR
        ANY PRODUCT OR SERVICE LICENSED, PURCHASED OR OTHERWISE MADE AVAILABLE THROUGH THE SITE IS
        PROVIDED "AS IS" WITH NO REPRESENTATIONS OR WARRANTIES OF ANY KIND, EITHER EXPRESSED OR IMPLIED. TO
        THE FULLEST EXTENT PERMISSIBLE PURSUANT TO APPLICABLE LAW, DevCare Vendor Management System (DVMS). AND ITS
        SUBSIDIARIES, AFFILIATES,
        SUPPLIERS, SPONSORS, AND AGENTS DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING, BUT NOT
        LIMITED TO THE IMPLIED WARRANTIES OF TITLE, MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
        NON-INFRINGEMENT NEITHER DevCare Vendor Management System (DVMS)., ITS SUBSIDIARIES, AFFILIATES, SPONSORS,
        SUPPLIERS,
        NOR AGENTS MAKES
        ANY REPRESENTATION AS TO THE RESULTS TO BE OBTAINED FROM THE USE OF THE SITE OR THE SITE-RELATED SERVICES.

    </p>
    <p>
        DEVCARE VENDOR MANAGEMENT SYSTEM (DVMS) AND ITS SUBSIDIARIES, AFFILIATES, SUPPLIERS, AND AGENTS DO NOT WARRANT
        THAT
        YOUR USE OF THE SITE OR THE SOFTWARE WILL BE UNINTERRUPTED, ERROR-FREE, OR SECURE, THAT DEFECTS WILL BE
        CORRECTED,
        OR THAT THE SITE (OR THE SERVER(S) ON WHICH HOSTED) OR SOFTWARE ARE FREE OF VIRUSES OR OTHER
        HARMFUL COMPONENTS. YOU ACKNOWLEDGE THAT YOU ARE RESPONSIBLE FOR OBTAINING AND MAINTAINING ALL TELEPHONE,
        COMPUTER
        HARDWARE AND OTHER EQUIPMENT NEEDED TO ACCESS AND USE THE SITE, AND ALL
        CHARGES RELATED THERETO. YOU ASSUME TOTAL RESPONSIBILITY AND RISK FOR YOUR USE OF THE SITE AND THE
        SOFTWARE AND YOUR RELIANCE THEREON. NO OPINION, ADVICE, OR STATEMENT OF DEVCARE VENDOR MANAGEMENT SYSTEM (DVMS)
        OR
        ITS
        SUBSIDIARIES, AFFILIATES, SUPPLIERS, AGENTS, REGISTERED USERS, OR VISITORS, WHETHER MADE ON THE SITE OR
        OTHERWISE,
        SHALL CREATE ANY WARRANTY. YOUR USE OF THE SITE AND ANY MATERIALS PROVIDED THROUGH THE SITE ARE ENTIRELY AT YOUR
        OWN
        RISK.

    </p>
    <p>
        You acknowledge that the Site could include inaccuracies, errors or materials that violate these Terms of Use
        (specifically, the "Code of Conduct" section). Additionally, you acknowledge that unauthorized additions,
        deletions
        and alterations could be made by third parties to the Site. Although the DevCare Vendor Management System (DVMS)
        attempts to ensure the Site's integrity and accuracy, it makes no guarantees of the Site's completeness or
        correctness. If a situation arises, please contact us at dvmsadmin@devcare.com. Please describe the material
        that
        needs reviewing and the location (URL) where changes may be required on the Site, including information
        sufficient
        to enable us to contact you. We will try to address your concerns as soon as reasonably practicable. See the
        "Claims
        of Copyright Infringement" section for copyright infringement claims.
    </p>
    <p>
        The Site is only a venue allowing for the posting by employers, recruiters and staffing agencies of available
        job
        opportunities at their companies or companies they represent (hereinafter referred to collectively as
        "employers") and
        by candidates' resumes. The DevCare Vendor Management System (DVMS) does not evaluate or censor the resumes, job
        listings or other information posted on the Site. Moreover, the DevCare Vendor Management System (DVMS) is not
        involved
        in the actual transaction between potential employers and candidates, if any. Consequently, we have no control
        over the
        quality, safety or legality of the job listings or resumes posted to the Site, the truth or accuracy of such job
        listings or resumes, the ability of employers to hire candidates or the ability of candidates to fill job
        openings.
    </p>
    <p>
        Because user authentication on the Internet is difficult, the DevCare Vendor Management System (DVMS) cannot and
        does
        not confirm that users are who they claim to be. Because we do not and cannot be involved in user-to-user
        transactions
        or control the behavior of the Site's users, in the event that you have a dispute with one or more Site users,
        you
        release DevCare Vendor Management System (DVMS) (and its subsidiaries, affiliates, agents and employees) from
        all
        claims, demands and damages (actual and consequential, direct and indirect) of any kind and nature, known and
        unknown,
        suspected and unsuspected, disclosed and undisclosed, arising out of or in any way related to such disputes. You
        acknowledge that there may be certain risks, including but not limited to physical harm and dealing with
        strangers,
        underage persons or people acting under false pretenses, associated with pursuing relationships begun on the
        Internet.
        You assume all risks related to dealing with other users you have contacted through the Site.
    </p>
    <p>
        You acknowledge and agree that you are solely responsible for the form, Content and accuracy of any resume, job
        listing or other material you post to the Site. The DevCare Vendor Management System (DVMS) neither warrants nor
        guarantees a specific number of users will view a resume or job posting or a resume or job listing will be
        viewed by
        any user. We are not to be considered an employer concerning your Site use. We shall not be responsible for any
        employment decisions made by any entity posting job listings or resumes to the Site.
        Limitation of Liability

    </p>
    <p>
        NEITHER DEVCARE VENDOR MANAGEMENT SYSTEM (DVMS) NOR ITS SUBSIDIARIES, AFFILIATES, SUPPLIERS, ADVERTISERS, AGENTS
        OR
        SPONSORS ARE
        RESPONSIBLE OR LIABLE FOR ANY INDIRECT, INCIDENTAL, CONSEQUENTIAL, SPECIAL, EXEMPLARY, PUNITIVE OR
        OTHER DAMAGES UNDER ANY CONTRACT, NEGLIGENCE, STRICT LIABILITY OR OTHER THEORY ARISING OUT OF OR
        RELATING IN ANY WAY TO THE SITE AND/OR CONTENT CONTAINED ON THE SITE, OR ANY PRODUCT OR SERVICE
        PURCHASED THROUGH THE SITE. YOUR SOLE REMEDY FOR DISSATISFACTION WITH THE SITE AND/OR CONTENT
        CONTAINED WITHIN THE SITE IS TO STOP USING THE SITE. THE SOLE AND EXCLUSIVE MAXIMUM LIABILITY TO
        DEVCARE VENDOR MANAGEMENT SYSTEM (DVMS) FOR ALL DAMAGES, LOSSES AND CAUSES OF ACTION (WHETHER IN CONTRACT, TORT,
        INCLUDING, WITHOUT LIMITATION, NEGLIGENCE OR OTHERWISE) SHALL BE THE TOTAL AMOUNT PAID BY YOU, IF ANY, TO ACCESS
        THE
        SITE.

    </p>
    <h2>Acknowledgment</h2>
    <p>
        This Site may contain links to other websites operated by third-party affiliates of the DevCare Vendor
        Management
        System (DVMS) ("Linked Sites"). We neither control nor endorse such other websites, nor have we reviewed or
        approved
        any content that appears on the Linked Sites.
        You acknowledge that when you click on a link to visit a Linked Site, a frame may appear that contains the
        DevCare
        Vendor Management System (DVMS) logo, advertisements and/or other Content selected by the DevCare Vendor
        Management
        System (DVMS). You acknowledge that the DevCare Vendor Management System (DVMS) and its sponsors neither endorse
        nor
        are affiliated with the Linked Sites and are not responsible for any content that appears on the Linked Sites.
        You
        also acknowledge that the owner of the Linked Site neither endorses nor is affiliated with the DevCare Vendor
        Management System (DVMS) and its sponsors.
        Void Where Prohibited; Indemnification

    </p>
    <p>
        Although the Site is accessible worldwide, not all products or services discussed, referenced or made available
        to all
        persons or in all geographic locations or jurisdictions. We make no representation that materials on the Site
        are
        appropriate or available for use in locations outside the United States. Those who choose to access the Site
        from other
        locations do so on their initiative and at their own risk and are responsible for compliance with local laws if
        and to
        the extent local laws are applicable. The DevCare Vendor Management System (DVMS) reserves the right to limit
        the
        availability of the Site and/or the provision of products or services described thereon to any person,
        geographic area,
        or jurisdiction it so desires. At any time, by our sole discretion, DevCare can limit the quantities of any
        product or
        service we provide.
    </p>
    <p>
        You agree to indemnify, defend and hold us, our affiliates, sponsors, officers, directors, employees, agents and
        representatives harmless from and against all claims, damages, losses, costs (including reasonable attorneys'
        fees),
        or other expenses that arise directly or indirectly out of or from (a) your breach of this Agreement, (b) your
        violation of the Code of Conduct, and/or (c) your activities in connection with the Site or Site-related
        services.
        Code of Conduct
        While using the Site or Site-related services, you agree not to do any of the following without our prior
        written
        authorization:

    </p>
    <!-- <ul> -->
    <p>Post any inaccurate, untimely, stale, incomplete or misleading information.</p>
    <p>Post any employment opportunity or requirements that are inaccurate or not available with a verifiable DevCare
        Vendor Management System (DVMS) directly represented by your office.</p>
    <p>
        Post any employment opportunities that are not technology-related or are outside a technology-related field or
        organization.
    </p>
    <p>
        Keycode (overuse of a skill set, term or definition within job posting, profile, resume or otherwise to gain
        priority
        placement), copy other job postings as your own, post the same position multiple times on the Site or post
        multiple
        positions within one posting.
    </p>
    <p>
        Place any contact information within a job posting that differs from or in addition to the contact information
        provided
        when subscribing to the DevCare Vendor Management System (DVMS) service.
    </p>
    <p>
        Post any employment opportunity that does not contain a DevCare Vendor Management System (DVMS) URL, email
        address or
        "apply online" application.
    </p>
    <!-- </ul> -->
    <p>
        Resell or make available to any person not expressly licensed by DevCare Vendor Management System (DVMS),
        whether via
        phone; fax; email; mail or any other medium. Any of the DevCare Vendor Management System (DVMS) services or any
        information obtained from there, including (without limitation) the Hotlist, resumes or candidate information.
    </p>
    <p>
        Share passwords, login information or named user identification or otherwise allow multiple offices or users to
        access
        the DevCare Vendor Management System (DVMS) service on a basis other than what is subscribed initially. A named
        user is
        defined; as one unique individual user with one unique password. An office is defined; as a location where a
        named user
        routinely accesses or uses the DevCare Vendor Management System (DVMS) service under an express license from
        DevCare
        Vendor Management System (DVMS).
    </p>
    <p>
        Use of any search engine, software, tool, electronic storage or retrieval device, agent or other device or
        mechanism,
        including without limitation browsers, spiders, robots, avatars or intelligent agents (collectively "Devices")
        that are
        not approved by DevCare Vendor Management System (DVMS) to navigate, search or store information from the Site.
        Supported Devices include those made available by DevCare Vendor Management System (DVMS) on the Site, or other
        generally available third-party web browsers, e.g., Mozilla Firefox, Google Chrome, Microsoft Internet Explorer,
        or
        generally available search engines, e.g., Google or Bing.
    </p>
    <p>
        Allow job postings or employment requirements to remain posted on the Site for more than 24 hours after they are
        no
        longer viable or valid. To the extent that a position is placed on "hold" or is otherwise not available for
        immediate
        placement, the posting must be removed from the Site until the position is a viable opening.
    </p>
    <p>
        Engage in spamming, flooding, soliciting or mass marketing via email, direct mail, telephone, or otherwise to
        DevCare
        Vendor Management System (DVMS) job seekers or subscribers.
    </p>
    <p>
        Express or imply that we endorse any statements you make.
    </p>
    <p>
        Impersonate any person or entity, including, without limitation, a DevCare Vendor Management System (DVMS)
        employee
        or agent, a user of DevCare Vendor Management System (DVMS) 's services, including a candidate, placement
        specialist
        or an employer, or otherwise misrepresent your affiliation with any person or entity.
        Respond to a job listing on behalf of anyone other than yourself.

    </p>
    <p>
        Delete or revise any material posted by any other person or entity.
    </p>
    <p>
        Restrict or inhibit any other user from using and enjoying the Site and services, including, without limitation,
        by
        means of "hacking" or defacing any portion of the Site.
    </p>
    <p>
        Post or transmit (a) any incomplete, false or inaccurate biographical information or information that is not
        your
        accurate resume (i.e., the resume of a living individual seeking employment on a full-time or part-time basis on
        his or
        her behalf); (b) any content or information that is unlawful, fraudulent, threatening, abusive, libelous,
        defamatory,
        obscene or otherwise objectionable or harmful, or that infringes on our or any third party's intellectual
        property or
        other rights; (c) any advertisements, solicitations, chain letters, pyramid schemes, investment opportunities,
        or other
        unsolicited commercial communication; (d) any information or software that contains a virus, worm, Trojan horse
        or
        another harmful or disruptive component; (e) any trade secret of any third party; or (f) any material, nonpublic
        information about companies without the authorization to do so.
    </p>
    <p>
        Post or transmit any job advertisement or posting that does not comply with applicable law, including but not
        limited to
        United States federal, state and local laws relating to equal employment opportunity and employment eligibility
        verification. Including posting or transmitting any job advertisement or posting that requires a visa as a
        condition of
        employment; or that requires United States citizenship or lawful permanent residence in the United States as a
        condition
        of employment, except when necessary to comply with the law, regulation, executive order, or government
        contract.
    </p>
    <p>
        Use the Site for any unlawful commercial, research or information-gathering purposes.
    </p>
    <p>
        Communicate, send, or place unsolicited emails, telephone calls, mailings or other contacts to posting
        individuals and
        entities.
    </p>
    <p>
        Modify, adapt, sublicense, translate, sell, reverse engineer, decompile or disassemble any portion of the Site.
    </p>
    <p>
        Remove copyright, trademark, or other proprietary rights notices from the Site. "Frame" or "mirror" any part of
        the Site.
    </p>
    <p>
        Link to any page of or material on the Site other than the URL located at https://dvms.devcare.com/.
    </p>
    <p>
        Use any robot, spider, site search/retrieval application, or other manual or automatic device or process to
        retrieve,
        index, "data mine," or reproduce or circumvent the navigational structure or presentation of the Site or its
        contents.
    </p>
    <p>
        Print out or otherwise copy or use any personally identifiable information about candidates for purposes other
        than
        consideration of the candidates for potential employment by your DevCare Vendor Management System (DVMS).
    </p>
    <p>
        DevCare Vendor Management System (DVMS) assumes no responsibility or liability for any personnel selected by
        your
        DevCare Vendor Management System (DVMS). Selection, retention or hire of any individual or entity is based
        solely on
        your DevCare Vendor Management System (DVMS) 's investigation, verification and determination that such
        engagement is
        suitable for your DevCare Vendor Management System (DVMS) 's purposes.
    </p>
    <p>
        You agree to and will hold the DevCare Vendor Management System (DVMS) harmless from any claims, damages or
        losses
        incurred by your DevCare Vendor Management System (DVMS) or any other party as a result of your use of the
        DevCare
        Vendor Management System (DVMS) system.
    </p>
    <p>
        You agree to comply with all applicable laws, rules and regulations concerning your use of the Site and
        Site-related services.
    </p>
    <p>
        The DevCare Vendor Management System (DVMS) has no obligation to monitor the Site or Site-related services,
        including any forum or any materials you or other third parties transmit or post. However, you acknowledge and
        agree
        that the DevCare Vendor Management System (DVMS) has the right (but not the obligation) to monitor the Site and
        Site-related services, including any forum and the materials you transmit or post. Altering or removing any
        materials (without limitation, any posting to the Site) and disclosing such materials and the circumstances
        surrounding their transmission. Any third party must operate the Site properly, protect itself, its sponsors,
        its
        registered users and visitors, and comply with legal obligations or governmental requests. The DevCare Vendor
        Management System (DVMS) reserves the right to refuse to post or to remove any information or materials, in
        whole or
        in part, that it deems in its sole discretion to be unacceptable, offensive or in violation of this Agreement.
        The
        DevCare Vendor Management System (DVMS) also reserves the right to prohibit any user who violates the Code of
        Conduct or other terms of this Agreement in the DevCare Vendor Management System (DVMS) 's sole discretion using
        the
        Site and related services. Such prohibition may occur without notice to the user.
        Restricted Rights Legend

    </p>
    <p>
        Use, duplication or disclosure by the Government is subject to the restriction as outlined in subparagraph
        (c)(1)(ii) of the Rights in Technical Data and Computer Software Clause as DFARS 252.227-7013 and FAR 52.227-19,
        as
        applicable. Supplier is DevCare Vendor Management System (DVMS)., 579 Executive Campus Drive, Suite 370
        Westerville-OH-43082.

    </p>
    <h2>Making Purchases</h2>
    <p>
        DevCare Vendor Management System (DVMS) products or services are available at the Site, and you wish to license
        or
        purchase products or services. In that case, you may be asked by the applicable merchant, service provider, or
        us to
        supply certain information, including a credit card or other information. If you submit such information, you
        understand that any such information will be treated by DevCare Vendor Management System (DVMS) in the manner
        described in our Privacy Policy. You agree that all information you provide to us or any such merchant or
        service
        provider will be accurate, complete and current. You agree to pay all charges incurred by you or any users of
        your
        account and credit card or another payment mechanism at the prices in effect when such charges are incurred. You
        will also be responsible for paying any applicable taxes relating to your purchases. You agree to review and
        comply
        with the terms and conditions of any specific agreement, if any that you enter into with the merchant and/or
        service
        provider in connection with the licensing or purchase of any product or Service.
        Submissions

    </p>
    <p>
        Because our designees and we host job boards and other forums found on the Site and elsewhere and, therefore,
        redistribute materials you give us, we require certain rights in those materials. Therefore, by sending or
        transmitting to us resources, information, ideas, notes, concepts, trademarks, service marks or other materials
        (including, but not limited to, job postings) (collectively, "Content"), or by posting such Content to any area
        of
        the Site, you grant us and our designees a worldwide, nonexclusive, sub-licensable (through multiple tiers),
        assignable, royalty-free, perpetual, irrevocable right to link to, reproduce, distribute
        (through multiple tiers), adapt, create derivative works of, publicly perform, publicly display, digitally
        perform
        or otherwise use such Content in any media now known or hereafter developed. You hereby grant the DevCare Vendor
        Management System (DVMS) permission to display your logo, trademarks and DevCare Vendor Management System (DVMS)
        name on the Site and in the press and other public releases or filings. Further, by submitting Content to the
        DevCare Vendor Management System (DVMS), you acknowledge that you have the authority to grant such rights to the
        DevCare Vendor Management System (DVMS). PLEASE NOTE THAT YOU RETAIN OWNERSHIP OF ANY COPYRIGHTS, TRADEMARKS AND
        SERVICE MARKS IN ANY CONTENT YOU SUBMIT.

    </p>
    <p>
        Communications between the DevCare Vendor Management System (DVMS) and the Site users are not confidential.
        Registration; Use of Secure Areas and Passwords

    </p>
    <p>
        Some areas of the Site may require you to register with us. When and if you register, you agree to (a) provide
        accurate,
        current, and complete information about yourself as prompted by our registration form (including your email
        address) and
        (b) maintain and update your information (including your email address) to keep it accurate, current, and
        complete. You
        acknowledge that should any information provided by you be found to be untrue, inaccurate, not current, or
        incomplete,
        and we reserve the right to terminate this Agreement with you and your use of the Site.
    </p>
    <p>
        As part of the registration process, your username will be your email address, and you will be asked to select a
        password. We may refuse to allow you to use a username that impersonates someone else, may be illegal and may be
        protected by trademark or other proprietary rights law. We may also refuse if vulgar or otherwise offensive
        language is
        used or that may be confusing, as determined by us in our sole discretion. You will be responsible for the
        confidentiality and use of your password and agree not to distribute, transfer or resell your use of or access
        to the
        Site to any third party. If more than one individual wishes to use a single password belonging to a registered
        user, In
        that case, such a registered user must request permission from the DevCare Vendor Management System (DVMS) in
        writing.
        It is understood that the DevCare Vendor Management System (DVMS) shall be under no obligation to approve any
        such
        request. If you are a job seeker who has reason to believe that your account with us is no longer secure, you
        must
        promptly change your password by updating your account information from the "My DevCare Vendor Management System
        (DVMS)"
        tab of the Site and immediately notifying us of the problem via email addressed to dvmsadmin@devcare.com. If you
        are a
        customer with a reason to believe that your account with us is no longer secure, you must promptly contact
        Customer
        Support via email at dvmsadmin@devcare.com. YOU ARE SOLELY AND ENTIRELY RESPONSIBLE FOR MAINTAINING THE
        CONFIDENTIALITY
        OF YOUR USERNAME AND PASSWORD AND SOLELY AND ENTIRELY RESPONSIBLE FOR ANY AND ALL ACTIVITIES THAT ARE CONDUCTED
        THROUGH
        YOUR ACCOUNT.
    </p>
    <h2>Claims of Copyright Infringement</h2>
    <p>
        The Digital Millennium Copyright Act of 1998 (the "DMCA") provides recourse for copyright owners who believe
        that
        material appearing on the Internet infringes their rights under U.S. copyright law. If you have a reasonable
        faith
        belief that materials hosted by us infringe your copyright, you (or your agent) may send us a notice requesting
        that
        the material be removed or access to it blocked. The notice must include the following information: (a) a
        physical
        or electronic signature of a person authorized to act on behalf of the owner of an exclusive right that is
        allegedly
        being infringed upon; (b) identification of the copyrighted work claimed to have been infringed upon (or if
        multiple
        copyrighted works located on the Site are covered by a single notification, a representative list of such
        works);
        (c) identification of the material that is claimed to be infringing or the subject of infringing activity, and
        information reasonably sufficient to allow us to locate the material on the Site; (d) the name, address,
        telephone
        number, and email address (if available) of the complaining party; (e) a statement that the complaining party
        has a
        good faith belief that use of the material in the manner complained of is not authorized by the copyright owner,
        its
        agent, or the law; and (f) a statement that the information in the notification is accurate, and under penalty
        of
        perjury, that the complaining party is authorized to act on behalf of the owner of an exclusive right that is
        allegedly infringed. If you believe in good faith that a notice of copyright infringement has been wrongly filed
        against you, the DMCA permits you to send us a counter-notice. Notices and counter-notices must meet the
        then-current statutory requirements of the DMCA; see http://www.loc.gov/copyright/ for details. Notices and
        counter-notices concerning the Site should be sent to <strong> Vendor Management System (DVMS)., 579 Executive
            Campus
            Drive, Suite 370
            Westerville-OH-43082, (tel) 614-221-2277, (fax) 614-388-5556, Attention: DVMS.</strong> We suggest you
        consult your legal
        advisor before filing a notice or counter-notice. Also, be aware that there can be penalties for false claims
        under
        the DMCA.

    </p>
    <h2>Miscellaneous</h2>
    <p>
        This Agreement is entered into in the State of Ohio and shall be governed by and construed in accordance with
        the
        laws of the State
        of Ohio, exclusive of its choice of law rules. Each party to this Agreement hereby submits to the exclusive
        jurisdiction of the state and federal courts sitting in the County of Ohio in the State of Ohio for any dispute
        arising under or in connection with this Agreement, the Site or any Site-related services, and waives any
        jurisdictional, venue or inconvenient forum objections to such courts. In any action to enforce this Agreement,
        the
        prevailing party will be entitled to costs and attorneys' fees. In the event that any of the provisions of this
        Agreement shall be held by a court or other tribunal of competent jurisdiction to be unenforceable, such
        provisions
        shall be limited or eliminated to the minimum extent necessary so that this Agreement shall otherwise remain in
        full
        force and effect and enforceable. Failure of any party to insist upon strict compliance with the terms and
        conditions of this Agreement shall not be deemed a waiver or relinquishment of any similar right or power at any
        subsequent time.

    </p>
    <p>
        This Agreement constitutes the entire agreement between the parties pertaining to the subject matter hereof, and
        all
        written or oral agreements between the parties hereto are expressly canceled. This Agreement is not assignable,
        transferable or sub-licensable by you except with prior written consent. Any heading, caption or section title
        contained
        in this Agreement is inserted only as a matter of convenience and in no way defines or explains any section or
        provision
        hereof. The DevCare Vendor Management System (DVMS) reserves the right in its sole discretion to terminate the
        use of
        the Site by a user at any time.
    </p>
    <p>
        Legal Notices
        Under Ohio Civil Code Section [number], Ohio residents are entitled to the following specific consumer rights
        information:

    </p>
    <p>
        Pricing Information: Current rates for our services may be obtained by calling us at, sending a fax to, or
        emailing the
        DevCare Vendor Management System (DVMS) Sales Department. We reserve the right to change fees, surcharges,
        monthly or
        other periodic subscription fees or to institute new fees at any time as provided in this Agreement.
    </p>
    <p>
        <strong>Complaints:</strong> The Consumer Protection Section ,Office of the Attorney General ,State Office
        Tower, 25th Floor ,30 East
        Broad Street ,Columbus,
        OH 43215-3428 614-466-4986 (complaints) ,Toll free in OH: 1-800-282-0515 ,TDD: 614-466-1393 ,E-mail:
        consumer@ag.ohio.gov ,
        Website - <a href="https://ohioattorneygeneral.gov/Individuals-and-Families/Consumers/File-A-Complaint.aspx"
            target="_blank">www.ohioattorneygeneral.gov/Individuals-and-Families/Consumers/File-A-Complaint.aspx</a>

    </p>
    <h2>Contact Us</h2>
    <p>
        DevCare Solutions Ltd <br>
        579 Executive Campus Dr, Suite 370, Westerville, OH-43082<br>
        614-221-2277<br>
        info@devcare.com<br>
        dvmsadmin@devcare.com<br>

    </p>
    <p>
        All rights reserved. Use of this site is subject to certain Terms and Conditions.
    </p>
</div>